export const Heading = {
  variants: {
    menuSection: ({ colorMode }: any): any => ({
      fontSize: '12px',
      color: colorMode === 'light' ? 'gray.500' : 'gray.400',
    }),
  },
};
